<div [ngStyle]="{'z-index':singleEndpointRecord.id__c}" class="fieldsHolder" id="{{singleEndpointRecord.id__c}}">

  <form [formGroup]="selectFormGroup">
    <div class="rightConner">
      <button *ngIf="showCopyOptions" (click)="removeEndpoint(singleEndpointRecord)" class="delete" data-cy="RemoveEndpoint"
              title="Remove Endpoint"><span class="material-icons">remove_circle_outline</span></button>
      <button *ngIf="showCopyOptions" (click)="copyEndpoint(singleEndpointRecord)" class="copy" data-cy="CopyEndpoint"
              title="Copy Endpoint"><span class="material-icons">content_copy</span></button>
      <button *ngIf="showEditOptions" (click)="cancelEditing(singleEndpointRecord)" class="delete" data-cy="RemoveEndpoint"
              title="Remove Endpoint"><span class="material-icons">cancel</span></button>
      <button *ngIf="showEditOptions" (click)="saveEndpointChanges(this.singleEndpointRecord)" class="copy" data-cy="SaveEndpoint"
              title="Save Changes"><span class="material-icons">check_circle</span></button>
    </div>

    <div class="singleFieldContainer">
      <div class="formItemTitle">Category:</div>
      <div>
        <select class="formSelector" name="category">
          <option value="{{category.id}}">{{category.name__v}}</option>
        </select>
      </div>
    </div>

    <div class="singleFieldContainer">
      <div class="formItemTitle">Source:</div>
      <select (change)="updateFieldValue($event.target.valueOf());" class="formSelectorForDocument"
              formControlName="selectedDocument" name="source" title="document_unbound__c">
        <option *ngFor="let document of documents" value="{{ document.id }}">{{ document.name }}</option>
      </select>
    </div>

    <div class="singleFieldContainer">
      <div class="formItemTitle">Substance Type:</div>
      <div>
        <select (change)="onSelectSubstanceType($event)" class="formSelector" formControlName="substanceType"
                name="substanceType">
          <option></option>
          <option *ngFor="let substanceType of substanceTypes"
                  [value]="substanceType.name">{{ substanceType.label }}</option>
        </select>
      </div>
    </div>

    <div class="singleFieldContainer">
      <div class="formItemTitle">Related Substance:</div>
      <div>
        <select (change)="onSelectRelatedSubstance($event);"
                class="formSelector"
                formControlName="relatedSubstance"
                name="relatedSubstance"
                title="related_substance__c">
          <option selected value=""></option>
          <option *ngFor="let relSubstance of filteredRelatedSubstances"
                  value="{{relSubstance.id}}">{{relSubstance.name}}</option>
        </select>
      </div>
    </div>

    <div class="singleFieldContainer">
      <div class="formItemTitle">Study Type:</div>
      <div>
        <select (change)="onSelectStudyType($event);"
                class="formSelector"
                formControlName="studyType"
                name="study-type">
          <option value=""></option>
          <option *ngFor="let studyType of studyTypes"
                  [title]="studyType.picklist"
                  [value]="studyType.name">{{ studyType.label }}</option>
        </select>
      </div>
    </div>

    <div class="singleFieldContainer">
      <div class="formItemTitle">Test System Type:</div>
      <div>
        <mat-form-field class="multiPicklistFormSelector">
          <mat-select
            (selectionChange)="onSelectTestSystemType($event)"
            class="angularFormSelector"
            formControlName="testSystemTypeMultiSelect"
            multiple
            ngDefaultControl title="test_system_type__c">
            <mat-option *ngFor="let testSystemType of testSystemTypes"
                        [title]="testSystemType.picklist"
                        [value]=" testSystemType.name ">{{ testSystemType.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="singleFieldContainer">
      <div class="formItemTitle">Test System Name:</div>
      <div>
          <select
            (change)="onSelectTestSystemName($event.target);"
            class="formSelector"
            formControlName="testSystemNameSingleSelect"
            title="test_system_name__c">
            <option value=""></option>
            <option *ngFor="let testSystemName of allTestSystemNames" [title]="testSystemName.picklist"
                        value="{{ testSystemName.name }}">{{ testSystemName.label }}
            </option>
          </select>
      </div>
    </div>

    <div class="singleFieldContainer" [hidden]="hiddenRDComponentsSingleSelect">
      <div class="formItemTitle">RD components:</div>
      <div>
          <select
            (change)="onSelectRDComponent($event.target, 'singleSelect');"
            class="formSelector"
            formControlName="rdComponentsSingleSelect"
            title="rd_components__c">
            <option value=""></option>
            <option *ngFor="let rdComponent of rdComponents"
                        value="{{ rdComponent.id }}">{{ rdComponent.name }}
            </option>
          </select>
      </div>
    </div>

     <div class="singleFieldContainer" [hidden]="hiddenRDComponentsMultiSelect">
      <div class="formItemTitle">RD components:</div>
      <div>
        <mat-form-field class="multiPicklistFormSelector">
          <mat-select
            (selectionChange)="onSelectRDComponent($event, 'multiSelect')"
            class="angularFormSelector"
            formControlName="rdComponentsMultiSelect"
            multiple
            ngDefaultControl title="rd_components__c">
            <mat-option *ngFor="let rdComponent of rdComponents"
                        [value]=" rdComponent.id ">{{ rdComponent.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngFor="let field of additionalFields" class="singleFieldContainer">
      <div class="formItemTitle">{{field.label}}:</div>
      <div [ngSwitch]="field.type">
        <textarea (change)="updateFieldValue($event.target.valueOf())"
                  (keyup)="updateFieldValue($event.target.valueOf())"
                  *ngSwitchCase="'text'"
                  [formControlName]="field.name" [title]="field.name" class="formFreeText" rows="1"></textarea>
        <select (change)="updateFieldValue($event.target.valueOf())" *ngSwitchCase="'picklist'"
                [formControlName]="field.name" [title]="field.name" class="formSelector">
          <option value=""></option>
          <option *ngFor="let opt of filterAdditionalFieldValues(allAdditionalFieldValues, field.picklist)"
                  [value]="opt.name">{{opt.label}}</option>
        </select>
      </div>
    </div>
  </form>
</div>
